import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {User} from 'domain-models'
import {useApp} from 'hooks/StateHooks'
import _ from 'lodash'
import React from 'react'
import {store} from 'store'
import AppNavigationModal from '../views/AppNavigationModal'
import DealerInformationModal from './DealerInformationModal'
import NotificationsModal from './NotificationsModal'
import SupportModal from './SupportModal'
import {connect} from 'react-redux'
import {GlobalState} from '../state'
import AuctionFilter from '../views/Auctions/AuctionFilter'
import AppHeaderItems from './AppHeaderItems'
import {SubjectType, updateApp} from '../redux/actions'
import {AppState} from '../redux/reducers/AppReducer'
import {classNames} from '../utils/class-names'
import {isLuxuryAuctionUser} from '../utils/luxury'
import Trans from './Trans'

type AppHeaderProps = {
  user: User,
  showFilters: boolean
  subjectType: SubjectType
  app: AppState
  isLoading: boolean
}

type AppHeaderState = {
  dropdownToggled: boolean
  showSupportModal: boolean
  showNotificationsModal: boolean
  showDealerInformationModal: boolean
}

class Header extends React.Component<AppHeaderProps, AppHeaderState> {
  _isMounted = false

  constructor(props: AppHeaderProps) {
    super(props)
    this.state = {
      dropdownToggled: false,
      showSupportModal: false,
      showNotificationsModal: false,
      showDealerInformationModal: false
    }
  };

  toggleDropdown = (event: MouseEvent | React.MouseEvent | false) => {
    event && event.stopPropagation() && event.preventDefault()
    if (this._isMounted) {
      this.setState({dropdownToggled: event ? !this.state.dropdownToggled : false})
    }
  }

  componentDidMount() {
    this._isMounted = true
    window.addEventListener('click', () => {
      this.toggleDropdown(false)
    }, false)
  };

  componentWillUnmount() {
    this._isMounted = false
    window.removeEventListener('click', this.toggleDropdown)
  }

  openSupportModal = () => {
    this.setState({
      showSupportModal: true
    })
  }

  hideSupportModal = () => {
    this.setState({
      showSupportModal: false
    })
  }

  openNotificationsModal = () => {
    this.setState({
      showNotificationsModal: true
    })
  }

  hideNotificationsModal = () => {
    this.setState({
      showNotificationsModal: false
    })
  }

  openDealerInformationModal = () => {
    this.setState({
      showDealerInformationModal: true
    })
  }

  hideDealerInformationModal = () => {
    this.setState({
      showDealerInformationModal: false
    })
  }

  changeSubjectType = (subjectType: SubjectType) => {
    if (this.props.isLoading || subjectType === this.props.subjectType) {
      return
    }

    const app = this.props.app

    app.subjectType = subjectType

    store.dispatch(updateApp(app))
  }

  render() {
    const dropdownToggled = this.state.dropdownToggled
    const luxury = isLuxuryAuctionUser(this.props.user)
    return (
      <div className='bg-blue-800 text-blue-100 w-full flex flex-row shadow select-none'>
        <div className='w-full flex flex-row justify-between lg:mx-8'>
          <div className='flex space-x-4 my-2'>
            <div className='lg:hidden flex items-center flex-row justify-center text-xl'>
              <AppNavigationModal />
            </div>

            {luxury ?
              <div className='flex items-center px-2'>
                <img src={(useApp().basename || '') + '/images/Emil_Frey_Gruppe_logo.png'} alt='Emil Frey'
                     className='h-8 w-auto'/>
                <span className='emilfrey-luxury-signature hidden lg:block ml-3 font-semibold text-lg text-blue-100'>
                  <Trans>Luxusauktion</Trans>
                </span>
              </div>
              :
              <React.Fragment>

            <div className={classNames(
              'hover:bg-blue-700 whitespace-nowrap flex items-center justify-center rounded space-x-4 px-4',
              this.props.subjectType === 'Vehicle' ? 'bg-blue-700' : '',
              this.props.isLoading ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'
            )} onClick={() => this.changeSubjectType('Vehicle')}>
              <Icon icon='car' className={'mr-2 h-4 w-4'} />
              <span className={'hidden lg:block'}><Trans>Fahrzeuge</Trans></span>
            </div>

            <div className={classNames(
              'hover:bg-blue-700 whitespace-nowrap flex items-center justify-center rounded space-x-4 px-4',
              this.props.subjectType === 'Tireset' ? 'bg-blue-700' : '',
              this.props.isLoading ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'
            )} onClick={() => this.changeSubjectType('Tireset')}>
              <svg className='mr-2 h-4 w-4' aria-hidden='true' focusable='false' data-prefix='fad' data-icon='tire' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
                <g className='fa-group'>
                  <path fill='currentColor' d='M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm0 48a143.36 143.36 0 0 1 64.08 15l-38.86 53.51a73.73 73.73 0 0 0-50.44 0L191.92 127A143.36 143.36 0 0 1 256 112zM113.52 277a145.25 145.25 0 0 1-1.52-21 143 143 0 0 1 41.13-100.75l38.75 53.34A79.28 79.28 0 0 0 176 256c0 .25.07.48.07.72zM232 398a144.57 144.57 0 0 1-103.68-75.29L191 302.36a79.77 79.77 0 0 0 41 29.57zm24-110a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm101.82 69.82A142.84 142.84 0 0 1 280 398v-66.07a79.77 79.77 0 0 0 41-29.57l62.68 20.36a144.24 144.24 0 0 1-25.86 35.1zm-21.89-101.09c0-.25.07-.48.07-.73a79.28 79.28 0 0 0-15.88-47.41l38.75-53.34A143 143 0 0 1 400 256a146.93 146.93 0 0 1-1.52 21.05z' className='fa-secondary' />
                  <path fill='currentColor' d='M256 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm0-224C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm0 448c-105.87 0-192-86.13-192-192S150.13 64 256 64s192 86.13 192 192-86.13 192-192 192z' className='fa-primary' />
                </g>
              </svg>
              <span className={'hidden lg:block'}><Trans>Räder</Trans></span>
            </div>

              </React.Fragment>
            }
          </div>
          <div className='flex items-center flex-row justify-center px-2'>
            <div className='mx-2'>
              {!luxury && this.props.showFilters && <AuctionFilter />}
            </div>

            <div className='relative px-2'>
              <div onClick={this.toggleDropdown} className='anchor cursor-pointer'>
                {luxury ?
                  <React.Fragment>
                    {_.get(store.getState(), 'app.unreadNotifications', []) ?
                      <Icon icon='bell' className='text-yellow-500 mr-2'/>
                      : null}
                    <span className='hidden lg:block pl-1 font-semibold text-blue-100 select-none whitespace-no-wrap'>
                      <span>{this.props.user.employee ? this.props.user.employee.Name : null}</span>
                    </span>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    {_.get(store.getState(), 'app.unreadNotifications', []) ?
                      <Icon icon='bell' className='text-yellow-500 absolute top-0' style={{left: '3.5rem'}} />
                      : null}
                    <img src={this.props.user.photo_url || (useApp().basename + '/images/undraw_profile_pic.png')} alt='profile' className='w-12 h-12 rounded-full shadow' />
                    <span className='hidden lg:block pl-3 font-semibold text-blue-100 select-none whitespace-no-wrap'>
                      <span>{this.props.user.employee ? this.props.user.employee.Name : null}</span>
                    </span>
                  </React.Fragment>
                }
              </div>
              {dropdownToggled ?
                <AppHeaderItems openSupportModal={this.openSupportModal} openNotificationsModal={this.openNotificationsModal} openDealerInformationModal={this.openDealerInformationModal} /> : null}
            </div>
          </div>
        </div>

        {this.state.showSupportModal ? <SupportModal hideModal={this.hideSupportModal} /> : null}

        {this.state.showNotificationsModal ?
          <NotificationsModal hideModal={this.hideNotificationsModal} /> : null}

        {this.state.showDealerInformationModal ?
          <DealerInformationModal hideModal={this.hideDealerInformationModal} /> : null}
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  user: state.user,
  showFilters: state.app.settings.showFilters,
  app: state.app,
  subjectType: state.app.subjectType,
  isLoading: state.auctions.loading
}))(Header)
